import React from 'react';
import _ from 'lodash';
import Button from 'components/Button';
import ListIcon from '@material-ui/icons/List';
import COLORS from 'shared/constants/colors';

const CreateBasicOrder = ({ handleNext }) => (
  <Button
    containerStyle={{
      backgroundColor: COLORS.BLACK,
      fontSize: '16px',
      borderRadius: '3px',
      padding: '12px',
      lineHeight: '1.5',
      color: COLORS.WHITE,
      fontWeight: '700',
    }}
    title='Create Basic Order'
    startIcon={<ListIcon />}
    onClick={() => _.isFunction(handleNext) && handleNext()}
  />
);

export default CreateBasicOrder;
